import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import OzOverlay from '@@/library/v4/components/OzOverlay.vue'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzDrawerStatic',
  props: {
    fullSize: { type: Boolean, default: false },
    darkMode: { type: [Boolean, String], default: 'auto' },
    xScrim: { type: Boolean, default: true },
    isScrimSpectral: { type: Boolean, default: false },
    shouldFadeIn: { type: Boolean, default: true },
    zIndexClass: { default: undefined },
    position: { default: 'fixed' },
    hideScrollbar: { type: Boolean, default: false },
    shouldAnimateOnAppear: { type: Boolean, default: true }
  },
  emits: ['scrim-click', 'scrim-esc'],
  setup(__props: any) {

const props = __props as { fullSize: boolean, darkMode: boolean | 'auto', xScrim: boolean, isScrimSpectral: boolean, shouldFadeIn: boolean, zIndexClass: 'z-modal2' | 'z-sidepanel', position: 'fixed' | 'absolute', hideScrollbar: boolean, shouldAnimateOnAppear: boolean };

/**
 * @file Mobile Static Drawer Modal
 */




const root = ref<InstanceType<typeof OzOverlay>>()
const modalContainer = ref<HTMLDivElement>()
const isTouchingTopOfScreen = ref(false)

onMounted((): void => {
  if (props.fullSize || modalContainer.value?.clientHeight >= root.value?.$el.clientHeight) {
    isTouchingTopOfScreen.value = true
  }
})

return { __sfc: true,props, root, modalContainer, isTouchingTopOfScreen, OzOverlay }
}

})